import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, Checkbox, Modal } from "antd";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";

import { crud } from "@/redux/crud/actions";
import { selectListItems } from "@/redux/crud/selectors";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import TextArea from "antd/lib/input/TextArea";
import HeaderContent from "@/layout/HeaderContent";


export default function UserView() {
    let { id } = useParams();
    let [data, setData] = useState([]);
    let [note, setNote] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);

    const dispatch = useDispatch();
    useEffect(() => {
        axios(`${API_BASE_URL}user/read/${id}`)
            .then(res => {
                setData(res.data.result)
            })
            .catch(err => {
               
            })
    }, []);
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const approve = () => {

        data.isActive = true
        dispatch(crud.update('business-listing', id, data))
            .then(res => {
                setData(datas => ({
                    ...datas,
                    isActive: true
                }))
                
            })
            .catch(err => {
                
            })
            ;
    }
    const disApprove = () => {

       
        
    }
    function onChange({ target: { value } }) {
        setNote(value)
    };
    return (
        <>
            <HeaderContent />
            <ul>
                <li>First Name: {data.fname}</li>
                <li>lname: {data.lname}</li>
                <li>city: {data.city}</li>
                <li>country: {data.country}</li>
                <li>email: {data.email}</li>
                <li>phone: {data.phone}</li>
                <li>reference:  </li>
                <li>status: {data.status ? "Active" : "Inactive"}</li>
            </ul>


        </>
    );
}
